import React from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import { PartnerPlanRatingVisibilityList, PartnerPlanRatingVisibilityFilter } from './components/PartnerPlan'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'
import { getEmployeeId } from 'utils/getEmployeeId'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./PartnerPlans.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class PartnerPlanRatingVisibilityView extends React.Component {
  static propTypes = {
    getPartnerPlanRatingVisibility: PropTypes.func,
    partnerPlanRatingVisibility: PropTypes.object.isRequired,
    updatePartnerPlanRatingVisibility: PropTypes.func.isRequired,
  }
  static defaultProps = {
    getPartnerPlanRatingVisibility: null,
  }
  constructor(props) {
    super(props)
    this.handleInitFilteredData = this.handleInitFilteredData.bind(this)
    this.handleChangeFilteredData = this.handleChangeFilteredData.bind(this)
    this.handlePlanYearTrigger = this.handlePlanYearTrigger.bind(this)
    this.handlePlanStageTrigger = this.handlePlanStageTrigger.bind(this)
    this.state = {
      filteredData: [],
      isPlanYearSearch: false,
      isPlanStageSearch: false,
      planYearSelected: getFiscalYearTimestamps().current.year,
      planStageSelected: 'interim',
      isInitialLoad: true,
    }
  }

  handleInitFilteredData() {
    this.setState({ filteredData: [] }, () => {
      this.setState({ isPlanYearSearch: false })
      this.setState({ isPlanStageSearch: false })
      this.setState({ isInitialLoad: true })
      this.setState({ planYearSelected: getFiscalYearTimestamps().current.year })
      this.setState({ planStageSelected: 'interim' })
      this.props.getPartnerPlanRatingVisibility(
        getEmployeeId(this.props.selectedPartner, this.props.currentUser),
        (getFiscalYearTimestamps().current.year - constants.PARTNERPLAN.PLAN_FILTER_PARTNER_YEAR),
      )
    })
  }

  handleDefaultFilteredData = () => {
    const filteredinfo = [...new Set(this.props.partnerPlanRatingVisibility.ratingVisibility)]
    return filteredinfo.filter(item => String(item.year) === getFiscalYearTimestamps().current.year && item.stage === 'interim')
  }

  handleChangeFilteredData(data) {
    // this.setState(() => ({filteredPersonalInfos:filteredinfo}))
    setTimeout(() => { this.setState({ filteredData: data }) }, 500)
    this.setState({ filteredData: data }, () => {})
    this.setState({ isInitialLoad: false })
  }

  handlePlanYearTrigger(isPlanYearSearch, planYearSelected) {
    this.setState({ isPlanYearSearch })
    this.setState({ planYearSelected })
  }

  handlePlanStageTrigger(isPlanStageSearch, planStageSelected) {
    this.setState({ isPlanStageSearch })
    this.setState({ planStageSelected })
  }

  render() {
    const { partnerPlanRatingVisibility, updatePartnerPlanRatingVisibility } = this.props
    if (partnerPlanRatingVisibility.isFetching) {
      return (<Loading pageLoading />)
    }

    const currentData = (this.state.isPlanYearSearch || this.state.isPlanStageSearch || !this.state.isInitialLoad)
      ? this.state.filteredData
      : this.handleDefaultFilteredData()

    return (
      <div className={styles.content}>
        <PartnerPlanRatingVisibilityFilter
          filteredData={currentData}
          onChangeFilteredData={this.handleChangeFilteredData}
          onInitFilteredData={this.handleInitFilteredData}
          onPlanStageSearchTrigger={this.handlePlanStageTrigger}
          onPlanYearSearchTrigger={this.handlePlanYearTrigger}
          partnerPlanRatingVisibility={partnerPlanRatingVisibility}
        />
        <section className={styles.section}>
          {partnerPlanRatingVisibility.fetched && partnerPlanRatingVisibility.ratingVisibility &&
          <PartnerPlanRatingVisibilityList
            header={`FY${this.state.planYearSelected} ${this.state.planStageSelected} Partner plan`}
            ratingVisibilityItems={currentData}
            updatePartnerPlanRatingVisibility={updatePartnerPlanRatingVisibility}
          />}
        </section>
      </div>
    )
  }
}

export default PartnerPlanRatingVisibilityView



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/PartnerPlanRatingVisibility.js